module.exports = __webpack_public_path__ + "static/media/Gold_banner1.94d46c0d.jpg";